import React from "react";

export const LegalSection = ({ heading, children, testId, highlight }) => (
  <section
    className={highlight ? "mb-8 border-2 border-brand-red rounded-lg p-4 sm:p-5 bg-brand-red/5" : "mb-8"}
    data-testid={testId}
  >
    {heading && (
      <h2 className="font-display font-black uppercase text-brand-red text-base sm:text-lg tracking-tight mb-3 leading-snug">
        {heading}
      </h2>
    )}
    <div className="space-y-4">{children}</div>
  </section>
);

export const LegalP = ({ children }) => (
  <p className="font-sans text-black text-sm sm:text-base leading-relaxed">{children}</p>
);

export const LegalList = ({ items }) => (
  <ul className="list-disc pl-5 space-y-2">
    {items.map((item, idx) => (
      <li key={idx} className="font-sans text-black text-sm sm:text-base leading-relaxed">
        {item}
      </li>
    ))}
  </ul>
);
